module.exports = __webpack_public_path__ + "img/wizard_wechat-group.9398df3c.png";